var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',{attrs:{"multiple":"","value":_vm.selectedCategories},on:{"change":_vm.onChange}},[_vm._l((_vm.categories),function(cat,key){return [_c('v-chip',{key:key,attrs:{"outlined":"","value":key}},[_vm._v(_vm._s(cat.name))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }